import { call, put, takeEvery } from 'redux-saga/effects'
import { api } from '../services/api'
import {
  getTWToken,
  getTWSecret,
} from '../services/cookies'
import { logRavenError, setUserContext } from '../services/raven'
import { publishTracking } from '../services/tracking'
import {
  LOGIN_PENDING_DETAILS,
  TWITTER_LOGIN_PENDING,
  TWITTER_LOGIN_SUCCESS,
  TWITTER_LOGIN_FAIL,
  CHANGE_AUTH_STATE,
} from '../actions/index'
import constants from '../constants/index'
import sendPostMessage from '../services/post-communication'

function* onTwitterLogin(action) {
  let payload = null
  try {
    const providerToken = yield call(getTWToken)
    const providerSecret = yield call(getTWSecret)
    payload = { providerToken, providerSecret }
    if (action && action.payload) {
      Object.assign(payload, action.payload)
    }
    const user = yield call(api.twitterLogin, payload)

    if (user.status === 202) {
      yield put({ type: LOGIN_PENDING_DETAILS, payload: user })
    } else if (user.status === 201) {
      yield put({ type: TWITTER_LOGIN_SUCCESS, payload: user })
      yield put({ type: CHANGE_AUTH_STATE, payload: user.data })

      if (!payload.isRedirectFlow) {
        yield call(sendPostMessage, {
          ...user.data,
          ...constants.USER_ACTIONS.login,
          loginMethod: 'twitter',
        })

        publishTracking({
          clientId: JSON.parse(user.config.data).client_id,
          userAction: 'sign in',
          origin: 'twitter',
          event: 'event44',
        })
      }

      yield call(setUserContext, { email: user.data.email })
    }
  } catch (e) {
    yield put({ type: TWITTER_LOGIN_FAIL, payload: e.response })
    yield call(logRavenError, 'TW login error', e, e.response)

    if (payload && !payload.isRedirectFlow) {
      publishTracking({
        userAction: 'login error',
        origin: 'twitter',
        event: 'event147',
      })
    }
  }
}

export default function* twitterLogin() {
  yield takeEvery(TWITTER_LOGIN_PENDING, onTwitterLogin)
}



// WEBPACK FOOTER //
// ./src/sagas/twitter.js